import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { SseService } from '../services/sse-service.service';
import { NotificationService } from '../services/notification-service.service';
import { DELETE_STATES, getStatusLabel, NotificationCommand, RESEND_STATES, ScheduleStatus, UpdateScheduleStateRequest } from '../model/notification-model';

export interface NotificationStatus {
  id: number;
  dataOra: string;
  stato: string;  // ← stringa libera
  messaggio: string;
  childList?: Array<{
    id: number;
    touchPointName: string;
    staticListName: string;
    airshipScheduleId: string;
    status: string;
    error: string | null;
  }>;
}

@Component({
  selector: 'app-notification-popup-menu',
  templateUrl: './notification-popup-menu.component.html',
  styleUrls: ['./notification-popup-menu.component.css']
})
export class NotificationPopupMenuComponent implements OnInit, OnDestroy {


  // Aggiungi al costruttore
  constructor(
    private sseService: SseService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) { }


  @Input() challengeId: number;
  @Input() visible = false;
  @Input() row: any;
  @Input() isDetailedView = false;
  @Output() onClose = new EventEmitter<void>();

  notification: NotificationStatus | null = null;
  isConnected = false;
  private sseSub: Subscription | null = null;

  // Aggiungi gli input

  notificationCommand = NotificationCommand;



  hasCommand(status: string, command: NotificationCommand): boolean {
    if (command === NotificationCommand.DELETE) return DELETE_STATES.indexOf(status) !== -1;
    if (command === NotificationCommand.RESEND) return RESEND_STATES.indexOf(status) !== -1;
    return false;
  }

  onRetry(): void {
    const request = new UpdateScheduleStateRequest();
    request.challengeId = this.row.challengeId;
    request.requestedStatus = ScheduleStatus.TO_BE_UPPLOAD_CSV;

    this.notificationService.updateScheduleState(request)
      .subscribe(() => console.log('Resend avviato'));
  }

  onCancel(): void {
    const request = new UpdateScheduleStateRequest();
    request.challengeId = this.row.challengeId;
    request.requestedStatus = ScheduleStatus.STOP_IN_PROCESS;

    this.notificationService.updateScheduleState(request)
      .subscribe(() => console.log('Stop avviato'));
  }


  ngOnInit(): void {
    const challengeId = this.row && this.row.challengeId ? this.row.challengeId : null;

    console.log('[NotificationPopupMenu] Init - challengeId:', challengeId, 'isDetailedView:', this.isDetailedView);

    // Popoliamo subito con i dati che già abbiamo dalla riga
    if (this.row) {
      this.notification = {
        id: this.row.headId != null ? this.row.headId : this.row.id,
        dataOra: this.row.notifyAt ? this.row.notifyAt : '',
        stato: this.row.status ? this.row.status : '',
        messaggio: this.row.message ? this.row.message : '',
        childList: this.row.childList || []  // ← usiamo il childList dal row
      };
      console.log('[NotificationPopupMenu] Notification loaded from row:', this.notification);
      var childListLen = this.notification.childList ? this.notification.childList.length : 0;
      console.log('[NotificationPopupMenu] isDetailedView flag:', this.isDetailedView, 'childList length:', childListLen);
      this.cdr.detectChanges();
    }

    if (challengeId) {
      this.startLiveUpdates(challengeId);
    }
  }


  ngOnDestroy(): void {
    this.stopLiveUpdates();
  }

  private startLiveUpdates(challengeId: number): void {
    this.sseSub = this.sseService
      .startChallengeUpdates(challengeId)
      .subscribe({
        next: (chunk: string) => {
          this.isConnected = true;
          this.parseChunk(chunk);
        },
        error: (err) => {
          console.error('SSE error:', err);
          this.isConnected = false;
        },
        complete: () => {
          this.isConnected = false;
        }
      });
  }

  private stopLiveUpdates(): void {

    if (this.sseSub) {
      this.sseSub.unsubscribe();
      this.sseSub = null;
    } this.sseSub = null;
    this.isConnected = false;
  }

  private parseChunk(chunk: string): void {
    var lines = chunk.split('\n');
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (line.indexOf('data:') === 0) {
        try {
          var json = JSON.parse(line.replace('data:', '').trim());
          if (json && json.status && this.notification) {
            this.notification.stato = json.status;
          }
        } catch (e) {
          // chunk parziale, ignora
        }
      }
    }
  }
  close(): void {
    this.visible = false;
    this.stopLiveUpdates();
  }



  onDetails(): void {
    // TODO: navigazione/apertura dettagli
  }

  getStatoLabel(stato: string): string {
    return getStatusLabel(stato);
  }

  onTriggerStartSchedule(): void {
    this.notificationService.triggerStartSchedule().subscribe({
      next: () => console.log('Trigger start schedule eseguito'),
      error: (err) => {
        console.error('SSE error:', err); // ← guarda cosa arriva qui
        this.isConnected = false;
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/views/notification/notification-popup-menu/notification-popup-menu.component.ts